export default class StoreRepository {
    constructor() {
        this._store = {};
    }
    getStore() {
        return this._store;
    }
    each(callback) {
        for (let id in this._store)
            callback(this._store[id]);
    }
    get(id) {
        return this._store[id.toString()];
    }
    storeItem(item) {
        // @ts-ignore
        this._store[item.id] = item;
    }
}
